import { useState, useEffect } from "react";
import { Helmet } from "fusion-plugin-react-helmet-async";
import Footer from "../shared/components/footer";
import Navbar from "../shared/components/navbar";
import { assetUrl } from "fusion-core";
import { useLocation, useNavigate } from "fusion-plugin-react-router";
import { EditQuoteDetails } from "../shared/utils/navigationUtils";
import { HotjarEventNames } from "../shared/utils/hotjarEventNames";
import { TrackHotjarEvent } from "../shared/utils/trackHotjarEvent";
import { clearAllStores } from "../shared/utils/storeUtils";

const mainCss = assetUrl("../styles/main.css");
const css = assetUrl("../styles/notFound.css");
const noAccount = assetUrl(
  "../assets/images/error_no-account.png?assetUrl=true"
);
const almostThere = assetUrl(
  "../assets/images/error_almost-there.png?assetUrl=true"
);
const noQuote = assetUrl("../assets/images/error_no-quote.png?assetUrl=true");

const BlockedAction = () => {
  const location = useLocation();
  const navigate = useNavigate(); // Add this line
  const params = new URLSearchParams(location.search);
  const errorType = params.get("type");

  const [heading, setHeading] = useState("");
  const [message, setMessage] = useState("");
  const [image, setImage] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [onClick, setOnClick] = useState(() => () => {});

  const handleNoAccountError = () => {
    setHeading(
      "It looks like the Uber account you logged in with is not a driver account."
    );
    setMessage(
      "We are unable to confirm your Driver details from Uber. To obtain a quote, you must be logged into your driver account on the device you are trying to get a quote from."
    );
    setImage(noAccount);
    setButtonText("Go to Uber Driver Site");
    setOnClick(() => () => {
      clearAllStores();
      window.location.href = "https://www.uber.com/global/en/sign-in/";
    });
  };

  const handleAlmostThereError = () => {
    setHeading("It looks like your Uber driver account is not set up yet");
    setMessage(
      "We asked Uber for your account details but they have said your Uber account details cannot be found. This may indicate that your Uber driver account is still in the onboarding stage."
    );
    setImage(almostThere);
    setButtonText("Go to Uber Driver Site");
    setOnClick(() => () => {
      clearAllStores();
      window.location.href = "https://www.uber.com/global/en/sign-in/";
    });
  };

  const handleNoQuoteError = () => {
    setHeading("We're sorry — no quote is available at this time");
    setMessage(
      "Unfortunately, based on the information you've provided, we're unable to offer a quote through our panel of insurers at the moment. We're constantly working to expand our panel and improve our coverage, so please check back again in the future.\nIf you think this may be a mistake, or if your details have changed, you can start a new quote at any time."
    );
    setImage(noQuote);
    setButtonText("Edit Quote Details");
    setOnClick(() => () => {
      EditQuoteDetails();
      navigate("/taxi/quote");
    });
  };

  const setErrorContent = (type) => {
    switch (type) {
      case "no-account":
        handleNoAccountError();
        break;
      case "almost-there":
        handleAlmostThereError();
        break;
      case "no-quote":
        handleNoQuoteError();
        break;
      default:
        break;
    }
  };

  const trackErrorEvent = (type) => {
    const eventMap = {
      "no-account": HotjarEventNames.TAXI_ERROR_NO_ACCOUNT,
      "almost-there": HotjarEventNames.TAXI_ERROR_ALMOST_THERE,
      "no-quote": HotjarEventNames.TAXI_ERROR_NO_QUOTE,
    };
    if (eventMap[type]) {
      TrackHotjarEvent(eventMap[type]);
    }
  };

  useEffect(() => {
    setErrorContent(errorType);
    trackErrorEvent(errorType);
  }, [errorType]);

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <link rel="stylesheet" href={mainCss} />
        <link rel="stylesheet" href={css} />
      </Helmet>

      <Navbar />
      <div className="mainBody">
        <div className="flex">
          <div className="form container">
            {image && <img src={image} className="margin-top-30 image" />}
            <h1 className="margin-top-30">{heading}</h1>
            <p className="margin-top-15 margin-bottom-0">{message}</p>
            <button
              type="button"
              className="getStartedButton margin-top-30 margin-bottom-30"
              onClick={onClick}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlockedAction;
